import _ from 'lodash';
import ApiURLs from '../../../../utils/ApiURLs';

const PAYMENT_LINK_LANG_HE = 'he';

// Appends ?lang=he to a payment-link URL when the partner is Hebrew-only;
// otherwise returns the URL unchanged (the page defaults to English).
function appendLangParam(url, profile) {
	if (!url) {
		return url;
	}
	const forceHebrew = _.get(profile, 'company.partners_ui.force_hebrew_only', false);
	if (!forceHebrew) {
		return url;
	}
	const separator = url.includes('?') ? '&' : '?';
	return `${url}${separator}lang=${PAYMENT_LINK_LANG_HE}`;
}

function getCommissionPercentage(booking) {
	const total_client_price = booking.deal?.cheapopoPricing?.cheapopoTotalPrice;
	const total_commission =
		booking?.deal?.cheapopoPricing?.agentPricing?.absolute_margin_total ||
		booking?.deal?.cheapopoPricing?.commissionTotal ||
		0;

	const commission_percentage =
		booking?.deal?.cheapopoPricing?.agentPricing?.margin_percentage ||
		(total_client_price > 0 ? (total_commission / total_client_price) * 100 : 0);

	return commission_percentage.toFixed(2);
}

function isPaymentLinkExpirationExists(booking) {
	return !!_.get(booking, 'payment.payment_link.expiration');
}

function isTokenExpired(booking) {
	const token_expiration_date = _.get(booking, 'payment.payment_link.expiration');

	if (!token_expiration_date) {
		return true;
	}

	const expiration_time = new Date(token_expiration_date);
	const current_time = new Date();

	return current_time > expiration_time;
}

function getPaymentLink(booking, profile) {
	const token = _.get(booking, 'payment.payment_link.token');

	if (!token) {
		console.log('Token is not available');
		return '';
	}

	return appendLangParam(ApiURLs.GET_PAYMENT_LINK.replace(':token', token), profile);
}

function getTimeFormatted(date) {
	return date.format('MMM D, YYYY hh:mm A') + ' (GMT)';
}

function getTravelersText(booking, t) {
	let travelers_text = booking.travelers.map((t) => `${t.first_name} ${t.last_name}`).join(', ');

	const children_count = _.get(booking, 'deal.details.children_count', 0) * _.get(booking, 'deal.details.room_count', 1);
	const children_ages = _.get(booking, 'deal.details.children_ages', []).map((age) =>
		age === 0 ? t('underOne') : age,
	);

	if (children_count > 0) {
		const childrenText = `${children_count} ${children_count > 1 ? t('Children') : 'Child'} (${children_count === 1 ? t('age') : t('ages')} ${children_ages.join(', ')})`;
		travelers_text += `\r\n+${childrenText}`;
	}

	return travelers_text;
}

export default {
	getCommissionPercentage,
	isPaymentLinkExpirationExists,
	isTokenExpired,
	getPaymentLink,
	appendLangParam,
	getTimeFormatted,
	getTravelersText
};
